import { z } from "zod";
import { CLAVES } from "../sat/catalogos.js";
import { conceptoSchema } from "./cotizacion.js";
import { ESTADOS_FACTURA } from "./estados.js";
const monto = z.string().regex(/^\d+(\.\d{1,6})?$/, "monto inválido");
export const facturaCreateSchema = z
    .object({
    clienteId: z.uuid(),
    proyectoId: z.uuid().optional(),
    cotizacionId: z.uuid().optional(),
    serie: z.string().trim().max(25).optional(),
    tipoComprobante: z.enum(CLAVES.tipoComprobante).default("I"),
    metodoPago: z.enum(CLAVES.metodoPago).default("PUE"),
    formaPago: z.enum(CLAVES.formaPago).default("03"),
    usoCfdi: z.enum(CLAVES.usoCfdi).default("G03"),
    exportacion: z.enum(CLAVES.exportacion).default("01"),
    moneda: z.enum(CLAVES.moneda).default("MXN"),
    tipoCambio: monto.optional(),
    condicionesDePago: z.string().max(1000).optional(),
    notas: z.string().max(8000).optional(),
    conceptos: z.array(conceptoSchema).min(1),
    relacionados: z
        .array(z.object({
        tipoRelacion: z.enum(CLAVES.tipoRelacion),
        uuids: z.array(z.uuid()).min(1),
    }))
        .optional(),
})
    .superRefine((f, ctx) => {
    // PPD siempre lleva FormaPago 99 y no admite otra: el pago se reporta
    // después con el complemento de pagos, no aquí.
    if (f.metodoPago === "PPD" && f.formaPago !== "99") {
        ctx.addIssue({
            code: "custom",
            path: ["formaPago"],
            message: "Con método PPD la forma de pago debe ser 99 (Por definir)",
        });
    }
});
/**
 * La clave de idempotencia la genera el cliente (el navegador) y viaja en el
 * header `Idempotency-Key`. Dos clicks en "Timbrar" mandan la misma clave, y
 * el backend devuelve el resultado del primero en vez de quemar otro timbre.
 */
export const timbrarSchema = z.object({
    idempotencyKey: z.uuid(),
});
export const cancelarFacturaSchema = z
    .object({
    motivo: z.enum(CLAVES.motivoCancelacion),
    /** Obligatorio con motivo 01: el CFDI que sustituye al cancelado. */
    uuidSustitucion: z.uuid().optional(),
})
    .superRefine((c, ctx) => {
    if (c.motivo === "01" && !c.uuidSustitucion) {
        ctx.addIssue({
            code: "custom",
            path: ["uuidSustitucion"],
            message: "El motivo 01 exige el UUID del comprobante que sustituye al cancelado",
        });
    }
    if (c.motivo !== "01" && c.uuidSustitucion) {
        ctx.addIssue({
            code: "custom",
            path: ["uuidSustitucion"],
            message: "Solo el motivo 01 acepta UUID de sustitución",
        });
    }
});
export const enviarFacturaSchema = z.object({
    destinatarios: z.array(z.email()).min(1).max(10),
    mensaje: z.string().max(4000).optional(),
});
export const listaFacturasQuerySchema = z.object({
    clienteId: z.uuid().optional(),
    proyectoId: z.uuid().optional(),
    estado: z.enum(ESTADOS_FACTURA).optional(),
    serie: z.string().optional(),
    uuid: z.uuid().optional(),
    desde: z.iso.date().optional(),
    hasta: z.iso.date().optional(),
    /** Solo PPD con saldo pendiente. Alimenta la pantalla de complemento de pagos. */
    soloPendientesDePago: z.stringbool().optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
    cursor: z.string().optional(),
});
//# sourceMappingURL=factura.js.map